<template>
    <label class="input _textarea" :class="{ hasError: v.$error }">
        <textarea
            class="input__text"
            rows="3"
            :placeholder="placeholder"
            v-model="text">
        </textarea>
        <span class="input__error" v-if="v.$error">{{ errorText }}</span>
    </label>
</template>

<script>
export default {
    name: "customTextarea",
    props: {
        value: {
            type: String,
            default: "",
        },
        v: {
            type: Object,
            required: true,
        },
        placeholder: {
            type: String,
            default: ""
        },
        errorText: {
            type: String,
            default: "Заполните обязательное поле"
        }
    },
    computed: {
        text: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            }
        }
    }
};
</script>
